// TODO: replace with shared util once moved to ui-widgets (or equivalent shared package)
export interface BuildPlanNameParams {
  offerName: string | null | undefined;
  providerName: string | null | undefined;
  providerId: string | null | undefined;
  speedMbps: number | null | undefined;
  isTransfer: boolean;
}

export function buildPlanName({
  offerName,
  providerName,
  providerId,
  speedMbps,
  isTransfer,
}: BuildPlanNameParams): string {
  if (isTransfer) {
    return `${offerName ?? ''} Service`;
  }

  if (providerId === 'att') {
    return speedMbps ? `AT&T ${speedMbps} mbps Internet` : 'AT&T Internet';
  }

  const resolvedProvider = providerName ?? '';
  const resolvedOffer = offerName ?? '';
  const includesProvider = resolvedOffer
    .toLowerCase()
    .includes(resolvedProvider.toLowerCase());
  const includesSpeed = resolvedOffer.toLowerCase().includes('mbps');
  const hasSpeed = Boolean(speedMbps);

  if (includesProvider && (includesSpeed || !hasSpeed)) {
    return resolvedOffer;
  }

  if (includesProvider && hasSpeed && !includesSpeed) {
    return `${resolvedOffer} (${speedMbps} mbps)`;
  }

  if (!includesProvider && (includesSpeed || !hasSpeed)) {
    return `${resolvedProvider} ${resolvedOffer}`;
  }

  return `${resolvedProvider} ${resolvedOffer} (${speedMbps} mbps)`;
}
